<template>
  <v-dialog v-model="show" max-width="500px" scrollable>
    <v-card v-if="hasFile">
      <empty-state text="No attached file(s) found." v-if="!fileHasFiles" />
      <v-carousel v-else>
        <v-carousel-item
          v-for="(file, i) in file.files"
          :key="i"
          :src="file.responsive_url"
          height="500px"
          eager
        >
        </v-carousel-item>
      </v-carousel>

      <v-card-title>
        <h4>File Details</h4>
      </v-card-title>
      <v-card-text class="pb-0 mt-2" style="height: 200px;">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>File Name</v-list-item-title>
            <v-list-item-subtitle>{{ file.name }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list flat subheader three-line>
          <v-list-item
            v-for="(fileInformationType, i) in file.file_information_types"
            :key="i"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                fileInformationType.label
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                fileInformationType.value
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions right>
        <v-container fluid>
          <v-row align="center">
            <v-col align-self="center" cols="12" sm="6">
              <v-btn block color="primary" :loading="loading" @click="download">
                Download
              </v-btn>
            </v-col>
            <v-col align-self="center" cols="12" sm="6">
              <v-btn block :loading="loading" @click="deleteDialog = true">
                Delete
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <ConfirmModal
      v-model="deleteDialog"
      title="Delete File?"
      message="Are you sure you want to delete the file?"
    >
      <v-btn
        text
        :disabled="loading"
        :loading="loading"
        @click="deleteDialog = false"
        >No</v-btn
      >
      <v-btn
        color="primary"
        text
        :disabled="loading"
        :loading="loading"
        @click="fileDelete"
        >Yes</v-btn
      >
    </ConfirmModal>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import EmptyState from '@/components/shared/EmptyState'
import ConfirmModal from '@/components/modals/ConfirmModal'

export default {
  components: {
    EmptyState,
    ConfirmModal
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: this.value,
      loading: false,
      snackbar: {
        show: false,
        message: null,
        color: null
      },
      deleteDialog: false
    }
  },

  computed: {
    ...mapState({
      file: state => state.file.fileDetails,
      tradie: state => state.tradies.tradieDetails,
      businessAdmin: state => state.businessAdmin.businessAdminDetails
    }),

    hasFile() {
      return this.file !== null
    },

    fileHasFiles() {
      return this.file.files.length > 0
    }
  },

  methods: {
    ...mapActions({
      downloadFile: 'file/downloadFile',
      deleteFile: 'file/deleteFile'
    }),

    ...mapMutations({
      clearFileDetails: 'file/clearFileDetails'
    }),

    async download() {
      const name = this.tradie
        ? this.tradie.full_name
        : this.businessAdmin.full_name
      const filename = name + ' - ' + this.file.name + '.zip'

      this.loading = true
      await this.downloadFile()
        .then(response => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: 'application/zip'
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {})
      this.loading = false
    },
    async fileDelete() {
      this.loading = true

      await this.deleteFile()
        .then(res => {
          this.clearFileDetails()
          this.$emit('reloadFileList')
        })
        .catch(e => {})

      this.loading = false
      this.show = false
      this.deleteDialog = false
    }
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped></style>
